<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('update_slider') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                 <form ref="form" :data-url='`/slider/update/${sliderdata.id}`' class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    
                  
                  <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('name') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="sliderdata.name"
                                   :required="true"
                                   :placeholder="$t('name')"/>
                    </div>
                    <div class="form-group row">
                        <label for="inputs_editor" class="col-sm-2 h-fit-content">
                            {{ $t('quotations') }}
                        </label>
                        <div class="col-sm-8">
                            <app-input type="text-editor"
                                       :required="false"
                                       id="text-editor-id"
                                       :label="$t('message_placeholder')" v-model="sliderdata.quotations"/>
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('url') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="sliderdata.url"
                                   :required="false"
                                   :placeholder="$t('url')"/>
                    </div>  
                    <div class="form-group row align-items-center">
                        <label for="number_input" class="col-sm-2 mb-sm-0">
                            {{ $t('order_on') }}
                        </label>
                        <app-input id="number_input"
                                   class="col-sm-8"
                                   type="number"
                                   v-model="sliderdata.order_on"
                                   :placeholder="$t('order_on')"/>
                    </div>
                    <div class="form-group row mb-0">
                        <label class="col-sm-2 mb-sm-0">
                            {{ $t('upload_image') }}
                            <small class="text-muted font-italic">
                                {{ $t('recommended_slider_size') }}
                            </small>
                        </label>
                        <div class="col-sm-4">
                            <app-input type="custom-file-upload"
                                       :label="$t('upload_your_file')"
                                       v-model="reqData.image"/>
                        </div>
                        <div class="custom-image-upload-wrapper" v-if="sliderdata.image">
                            <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="sliderdata.image"                           :alt-text="$t('not_found')"/>         
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('status') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="statusLists"
                                       v-model="sliderdata.status"
                                       :required="true"/>
                    </div>
                  <div class="mt-5 action-buttons">
                      <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                          {{ $t('submit')}}
                      </button>
                      <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                          {{ $t('clear') }}
                      </button>
                  </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {axiosPost} from "../../../../Helpers/AxiosHelper";  
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    import * as actions from '../../../../Config/ApiUrl';
    export default {
        name: "UpdateSlider",
        mixins: [FormMixin],
        props: ['sliderdata'],
        data(){
          return {           
            preloader: false, 
            reqData:{},               
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ]
          }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData();
                for (const [key, value] of Object.entries(this.sliderdata)) {
                   if (value != null) formData.append(key, value);
                }
                if (this.reqData.image) {
                    formData.append("image", this.reqData.image);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                console.log(res);
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>